import { render, staticRenderFns } from "./ParkingRecord.vue?vue&type=template&id=5e708296&scoped=true"
import script from "./ParkingRecord.vue?vue&type=script&lang=js"
export * from "./ParkingRecord.vue?vue&type=script&lang=js"
import style0 from "./ParkingRecord.vue?vue&type=style&index=0&id=5e708296&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e708296",
  null
  
)

export default component.exports